import media from './media';
import widgetInfo from './widgetInfo';
import modalSettings from './modalSettings';
import renderSettings from './renderSettings';
import isBeingDragged from './isBeingDragged';

const root = {
	media,
	widgetInfo,
	modalSettings,
	renderSettings,
	isBeingDragged
};

export default root;
